import React from 'react';
import CompanyListRow from './CompanyListRow';
import SortableHead from '../../common/list/SortableHead';
import * as companyActions from '../../../actions/companyActions';
import { injectIntl } from 'react-intl';
import {messages} from  '../../common/Translations';

class CompaniesList extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidUpdate() {
        if(this.expectedConfirmationSelect) {
            this.expectedConfirmationSelect.value = this.expectedConfirmationSelect.getAttribute('data-count');
            this.expectedConfirmationSelect = null;
        }
    }

    render() {
        let {companies, listId, categoryOptions, onDelete, loginAs, actionParams, onRestore, adminCompanyId, showPortals, intl} = this.props;

        return (
            <div>
                <table className="table table-striped">
                    <SortableHead
                        listId={listId}
                        action={companyActions.loadCompanies}
                        actionParams={actionParams}
                        columns={[
                            {
                                title: '#',
                                name: 'id',
                            },
                            {
                                title: intl.formatMessage(messages.name),
                                name: 'name',
                            },
                            {
                                title: intl.formatMessage(messages.email),
                                name: 'email',
                            },
                            {
                                title: 'Abonnementstype',
                                name: 'subscriptionType',
                            },
                            {
                                title: intl.formatMessage(messages.actions),
                                className: 'text-right',
                            },
                        ]}
                    />
                    <tbody>
                    {
                        companies.map(company => <CompanyListRow
                            key={company.id}
                            company={company}
                            categoryOptions={categoryOptions}
                            onDelete={onDelete}
                            loginAs={loginAs}
                            onRestore={onRestore}
                            listId={listId}
                            adminCompanyId={adminCompanyId}
                            showPortals={showPortals}
                        />)
                    }
                    </tbody>
                </table>
            </div>
        );
    }
}

export default injectIntl(CompaniesList);


// WEBPACK FOOTER //
// ./web/src/components/company/list/CompaniesList.jsx